export default "__VITE_ASSET__599fad77__"